// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hftbhdkybvxytmenejmx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhmdGJoZGt5YnZ4eXRtZW5lam14Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2MjMxMTYsImV4cCI6MjA2ODE5OTExNn0.MH34XUl6mxjadSQdpFMnVN-Mvz3tHuRCt4sGcr9FUZA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});